import type { ThemeRegistration } from "shiki/core";

/**
 * Editorial code needs a small, restrained vocabulary: syntax should clarify
 * structure without competing with the surrounding article or diagram colors.
 */
export const gaCodeLightTheme: ThemeRegistration = {
  name: "ga-code-light",
  type: "light",
  colors: { "editor.background": "#fbfaf7", "editor.foreground": "#28241f" },
  settings: [
    { settings: { foreground: "#28241f" } },
    { scope: ["comment"], settings: { foreground: "#625a51" } },
    {
      scope: ["keyword", "storage", "storage.type"],
      settings: { foreground: "#a53634" },
    },
    { scope: ["string", "string.quoted"], settings: { foreground: "#066a45" } },
    {
      scope: ["constant.numeric", "constant.language"],
      settings: { foreground: "#914a06" },
    },
    {
      scope: ["entity.name.function", "support.function"],
      settings: { foreground: "#1a5f9c" },
    },
    {
      scope: ["entity.name.type", "support.type"],
      settings: { foreground: "#7448a0" },
    },
  ],
};

export const gaCodeDarkTheme: ThemeRegistration = {
  name: "ga-code-dark",
  type: "dark",
  colors: { "editor.background": "#11110f", "editor.foreground": "#ded9cf" },
  settings: [
    { settings: { foreground: "#ded9cf" } },
    { scope: ["comment"], settings: { foreground: "#8b8377" } },
    {
      scope: ["keyword", "storage", "storage.type"],
      settings: { foreground: "#df8d88" },
    },
    { scope: ["string", "string.quoted"], settings: { foreground: "#85c8ad" } },
    {
      scope: ["constant.numeric", "constant.language"],
      settings: { foreground: "#dfb47c" },
    },
    {
      scope: ["entity.name.function", "support.function"],
      settings: { foreground: "#9abcf0" },
    },
    {
      scope: ["entity.name.type", "support.type"],
      settings: { foreground: "#c5aae6" },
    },
  ],
};
